/**
 * Portfolio Screen
 *
 * Displays portfolio positions, trades, and (as an in-screen tab) the watchlist.
 * Watchlist is now a tab inside PortfolioTab (between Positions and Trades),
 * reached without leaving the screen. Shows different content based on auth.
 * NOW THEME-AWARE
 */

import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { PortfolioTab } from '../../components/portfolio/PortfolioTab';
import { PortfolioEmpty } from '../../components/portfolio/PortfolioEmpty';

export function PortfolioScreen() {
  const { isAuthenticated, isInitialized } = useAuth();
  const { theme } = useTheme();
  const styles = useMemo(() => createThemedStyles(theme), [theme]);

  // Show loading while checking auth
  if (!isInitialized) {
    return <View style={styles.container} />;
  }

  // Show login prompt if not authenticated
  if (!isAuthenticated) {
    return <PortfolioEmpty />;
  }

  // Show portfolio tabs if authenticated (watchlist is now one of the tabs)
  return (
    <View style={styles.container}>
      <PortfolioTab />
    </View>
  );
}

/**
 * Create themed styles dynamically
 */
function createThemedStyles(theme: any) {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
  });
}
